import { render, staticRenderFns } from "./TicketInfo.vue?vue&type=template&id=c07edd70&scoped=true&"
import script from "./TicketInfo.vue?vue&type=script&lang=js&"
export * from "./TicketInfo.vue?vue&type=script&lang=js&"
import style0 from "./TicketInfo.vue?vue&type=style&index=0&id=c07edd70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07edd70",
  null
  
)

export default component.exports